import(/* webpackMode: "eager" */ "/vercel/path0/fastpeps-core-storefront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/fastpeps-core-storefront/src/modules/common/components/localized-client-link/index.tsx");
